import React, { useState, Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid'; // Using Heroicons v2
import luckblock from '../../assets/images/luckblocks.png';
import hamburger from '../../assets/utility/hamburger.png';
import close from '../../assets/utility/close.png';
import twitter from '../../assets/socialIcons/twitter.png';
import telegram from '../../assets/socialIcons/telegram.png';

function FetchConnectionButton() {
  // Ensure the custom element is registered or handled appropriately
  // For now, rendering it directly as provided.
  return <appkit-button balance="show" label="Connect Wallet" loadingLabel="Connecting.." />;
}

// Helper function for dropdown items
function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const Header = () => {
  const [isMobileMenu, setMobileMenu] = useState(false);
  const navigate = useNavigate();

  const handleMobileMenu = () => {
    setMobileMenu((prevState) => !prevState);
  };

  const closeMobileMenu = () => {
    setMobileMenu(false);
  };

  // Função para navegar para páginas específicas com parâmetros de estado
  const navigateToPage = (path, stateParam, stateValue) => {
    navigate(path, { state: { [stateParam]: stateValue } });
    closeMobileMenu();
  };

  const menuItems = [
    {
      name: 'Raffle Lottery',
      isDropdown: true,
      items: [
        { name: 'BTC', path: '/' },
        { name: 'ETH', path: '/ethereum' },
        { name: 'POL', path: '/matic' },
        { name: 'CRANNI', path: '/CRANNI' },
        { name: 'My Tickets', path: '/my-tickets' },
      ],
    },
    {
      name: 'Games',
      isDropdown: true,
      items: [
        { name: 'Bull Vs Bear', path: '/prediction' },
      ],
    },
    {
      name: 'NFTnodes',
      isDropdown: true,
      items: [
        { name: 'About', path: '/nftnodes' },
        { name: 'Mint/Buy', path: '/nftnodes?section=mintbuy' },
        { name: 'Dashboard', path: '/nftnodes?section=dashboard' },
      ],
    },
    {
      name: 'Token',
      isDropdown: true,
      items: [
        { name: 'Overview', path: '/token' },
        { name: 'Staking', path: '/token?section=staking' }, // Link direto para staking
        { name: 'Cynths', path: '/token?section=cynths' }, // Link direto para cynths
      ],
    },
    { name: 'Docs', path: 'https://docs.luckblocks.com', isExternal: true, isDropdown: false },
  ];

  return (
    <header className="w-full flex bg-[#000000] text-white font-tcbnormal justify-center sticky top-0 z-50"> {/* Increased z-index */}
      <div className="max-w-screen-2xl w-full flex justify-between items-center p-3">
        <h1>
          <Link to="/">
            <img className="w-56 md:w-[300px]" src={luckblock} alt="logo" />
          </Link>
        </h1>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-4">
          {menuItems.map((item) =>
            item.isDropdown ? (
              <Menu as="div" className="relative inline-block text-left" key={item.name}>
                <div>
                  <Menu.Button className="inline-flex w-full justify-center items-center rounded-md px-4 py-2 text-lg font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                    {item.name}
                    <ChevronDownIcon
                      className="ml-2 -mr-1 h-5 w-5 text-violet-200 hover:text-violet-100"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-700 rounded-md bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50"> {/* Added z-index */}
                    <div className="px-1 py-1 ">
                      {item.items.map((subItem) => (
                        <Menu.Item key={subItem.name}>
                          {({ active }) => (
                            subItem.action ? (
                              <button
                                onClick={subItem.action}
                                className={classNames(
                                  active ? 'bg-violet-500 text-white' : 'text-gray-100',
                                  'group flex w-full items-center rounded-md px-2 py-2 text-sm font-tcbnormal text-left'
                                )}
                              >
                                {subItem.name}
                              </button>
                            ) : subItem.isExternal ? (
                              <a
                                href={subItem.path}
                                target="_blank"
                                rel="noreferrer"
                                className={classNames(
                                  active ? 'bg-violet-500 text-white' : 'text-gray-100',
                                  'group flex w-full items-center rounded-md px-2 py-2 text-sm font-tcbnormal'
                                )}
                              >
                                {subItem.name}
                              </a>
                            ) : (
                              <Link
                                to={subItem.path}
                                className={classNames(
                                  active ? 'bg-violet-500 text-white' : 'text-gray-100',
                                  'group flex w-full items-center rounded-md px-2 py-2 text-sm font-tcbnormal'
                                )}
                              >
                                {subItem.name}
                              </Link>
                            )
                          )}
                        </Menu.Item>
                      ))}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            ) : item.isExternal ? (
              <a
                key={item.name}
                href={item.path}
                target="_blank"
                rel="noreferrer"
                className="px-4 py-2 text-lg font-medium text-white hover:bg-opacity-30 rounded-md"
              >
                {item.name}
              </a>
            ) : (
              <Link
                key={item.name}
                to={item.path}
                className="px-4 py-2 text-lg font-medium text-white hover:bg-opacity-30 rounded-md"
              >
                {item.name}
              </Link>
            )
          )}
          <div className="pl-4">
            <FetchConnectionButton />
          </div>
        </nav>

        {/* Mobile Navigation Button */}
        <button onClick={handleMobileMenu} className="flex lg:hidden">
          <img src={hamburger} alt="menu" className=" w-6 md:w-9" />
        </button>

        {/* Mobile Menu Panel */}
        <div
          className={`fixed inset-0 z-50 transform transition-transform duration-500 ease-in-out ${isMobileMenu ? 'translate-x-0' : 'translate-x-full'} lg:hidden`}
        >
          <div className="fixed inset-0 bg-black bg-opacity-75" onClick={closeMobileMenu}></div> {/* Overlay */}
          <div className="fixed right-0 top-0 w-4/5 max-w-sm h-full bg-[#0d0d0d] p-5 shadow-xl overflow-y-auto">
            <div className="w-full flex justify-between items-center gap-3 mb-10">
              <h2>
                <img className="w-[200px]" src={luckblock} alt="logo" />
              </h2>
              <button onClick={handleMobileMenu}>
                <img src={close} alt="close menu" className="w-5" />
              </button>
            </div>

            <nav className="flex flex-col space-y-4">
              {menuItems.map((item) =>
                item.isDropdown ? (
                  <Menu as="div" className="relative w-full text-left" key={item.name}>
                    <Menu.Button className="flex w-full justify-between items-center rounded-md px-3 py-2 text-lg font-medium text-white hover:bg-gray-700">
                      {item.name}
                      <ChevronDownIcon className="ml-2 h-5 w-5" aria-hidden="true" />
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="mt-1 w-full origin-top-right rounded-md bg-gray-700 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="px-1 py-1">
                          {item.items.map((subItem) => (
                            <Menu.Item key={subItem.name}>
                              {({ active }) => (
                                subItem.action ? (
                                  <button
                                    onClick={subItem.action}
                                    className={classNames(
                                      active ? 'bg-violet-500 text-white' : 'text-gray-100',
                                      'group flex w-full items-center rounded-md px-3 py-2 text-base font-tcbnormal text-left'
                                    )}
                                  >
                                    {subItem.name}
                                  </button>
                                ) : subItem.isExternal ? (
                                  <a
                                    href={subItem.path}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={closeMobileMenu}
                                    className={classNames(
                                      active ? 'bg-violet-500 text-white' : 'text-gray-100',
                                      'group flex w-full items-center rounded-md px-3 py-2 text-base font-tcbnormal'
                                    )}
                                  >
                                    {subItem.name}
                                  </a>
                                ) : (
                                  <Link
                                    to={subItem.path}
                                    onClick={closeMobileMenu} // Close menu on link click
                                    className={classNames(
                                      active ? 'bg-violet-500 text-white' : 'text-gray-100',
                                      'group flex w-full items-center rounded-md px-3 py-2 text-base font-tcbnormal'
                                    )}
                                  >
                                    {subItem.name}
                                  </Link>
                                )
                              )}
                            </Menu.Item>
                          ))}
                        </div>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                ) : item.isExternal ? (
                  <a
                    key={item.name}
                    href={item.path}
                    target="_blank"
                    rel="noreferrer"
                    onClick={closeMobileMenu}
                    className="block px-3 py-2 rounded-md text-lg font-medium text-white hover:bg-gray-700"
                  >
                    {item.name}
                  </a>
                ) : (
                  <Link
                    key={item.name}
                    to={item.path}
                    onClick={closeMobileMenu}
                    className="block px-3 py-2 rounded-md text-lg font-medium text-white hover:bg-gray-700"
                  >
                    {item.name}
                  </Link>
                )
              )}
            </nav>

            <div className="w-full flex justify-center px-3 py-8 mt-8 border-t border-gray-700">
              <FetchConnectionButton />
            </div>
            <div className="flex justify-center gap-8 p-3">
              <a
                href="https://t.me/luckblockscom"
                target="_blank"
                rel="noreferrer"
                onClick={closeMobileMenu}
              >
                <img src={telegram} alt="telegram" className="h-10" />
              </a>
              <a
                href="https://twitter.com/luckblockscom"
                target="_blank"
                rel="noreferrer"
                onClick={closeMobileMenu}
              >
                <img src={twitter} alt="twitter" className="h-10" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
